import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ExsepComponent } from './exsep.component';
import { ExpertProfileComponent } from './pages/expert-profile/expert-profile.component';
import { SopraServicesComponent } from './pages/sopra-services/sopra-services.component';
import { SopraServiceDetailsComponent } from './pages/sopra-service-details/sopra-service-details.component';
import { ServicesRequestComponent } from './pages/services-request/services-request.component';
import { ServiceRequestDetailsComponent } from './pages/service-request-details/service-request-details.component';


const routes: Routes = [
  {
    path: '',
    component: ExsepComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'sopra-profile' },
      { 
        path: 'sopra-profile', 
        component: ExpertProfileComponent,
        data: {
          config: {
            expertType: 'sopra',
            pageTitle: 'طلبات المتقدمين لسوبرا',
            filterPage: 'SOPRA_EXPERTS',
            statusLabel: 'حالة ملف سوبرا',
            rejectDialogTitle: 'رفض طلب ملف سوبرا'
          }
        }
      },
      { 
        path: 'ayen-profile', 
        component: ExpertProfileComponent,
        data: {
          config: {
            expertType: 'ayen',
            pageTitle: 'طلبات المتقدمين لعاين',
            filterPage: 'AYEN_EXPERTS',
            statusLabel: 'حالة ملف عاين',
            rejectDialogTitle: 'رفض طلب ملف عاين'
          }
        }
      },
      {
        path: 'services',
        component: SopraServicesComponent
      },
      {
        path: 'service/:id',
        component: SopraServiceDetailsComponent
      },
      { 
        path: 'services-requests', 
        component: ServicesRequestComponent,
        data: {
          config: {
            expertType: 'sopra',
            pageTitle: 'طلبات المتقدمين لخدمات سوبرا',
            filterPage: 'CLASSIFICATION_APPLICATIONS',
          }
        }
      },
      { 
        path: 'services-requests/:id', 
        component: ServiceRequestDetailsComponent
      },
      
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ExsepRoutingModule {}
